export const noEmojies = /^([\u{0020}-\u{25FF}\u{27C0}-\u{FFFF}]+)$/u;
